var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _ellipse5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse6, _path10, _ellipse7, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000000907(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 414,
    viewBox: "0 0 356 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 355.805,
    height: 378.186,
    transform: "translate(0 35)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.049,
    cy: 166.105,
    rx: 118.51,
    ry: 131.105,
    fill: "#E9F5F0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7691,
    cy: 223.2,
    rx: 33.7691,
    ry: 37.358,
    fill: "#E9F5F0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.665,
    cy: 80.8164,
    rx: 23.5747,
    ry: 26.0801,
    fill: "#E9F5F0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9447,
    cy: 14.5563,
    rx: 27.9447,
    ry: 14.5563,
    transform: "matrix(0.887704 -0.460415 0.390198 0.920731 114.688 386.381)",
    fill: "#DEEDFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.035 39.3245L154.125 42.6771C153.888 43.5512 154.843 44.265 155.614 43.7908L164.693 38.2108C164.851 38.1141 165.032 38.0628 165.217 38.0628H177.314C177.867 38.0628 178.314 37.6151 178.314 37.0628V15.0973C178.314 14.545 177.867 14.0973 177.314 14.0973H140.448C139.896 14.0973 139.448 14.545 139.448 15.0973V37.0628C139.448 37.6151 139.896 38.0628 140.448 38.0628H154.069C154.728 38.0628 155.207 38.6887 155.035 39.3245Z",
    fill: "#FFC648"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.562,
    cy: 18.3265,
    rx: 10.1944,
    ry: 11.2779,
    fill: "#E84C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.102 18.3265L157.288 21.8508L163.66 13.3924",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.125 90.6958L221.349 94.1175C220.978 95.8035 212.471 99.8213 208.263 101.619L204.125 90.6958Z",
    fill: "#912E04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.239 99.8479C206.165 104.653 204.194 96.397 204.634 91.7125C204.634 91.7125 207.08 88.3801 207.651 87.4516C208.222 86.5231 209.359 83.5821 209.359 83.5821L226.341 79.7681L219.514 95.7879C219.133 96.4069 218.119 96.3458 213.239 99.8479Z",
    fill: "#FFA171"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.653 99.2275C202.781 93.8516 202.484 93.7038 204.691 91.457C204.691 91.457 204.288 99.3986 211.064 100.006C217.84 100.614 204.524 104.603 203.653 99.2275Z",
    fill: "#F37F4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.913 87.8418C219.022 90.8525 211.06 88.9108 207.623 87.5792L209.287 83.6303L225.828 80.712L222.913 87.8418Z",
    fill: "#F37F4E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.69 36.8953C196.539 37.976 204.071 46.704 208.606 50.9329C210.481 58.4796 216.212 75.506 224.138 83.2381C232.064 90.9703 233.999 82.6095 233.975 77.4626C246.199 80.095 248.146 64.5347 247.592 56.4255C255.024 50.0731 250.649 44.6241 247.532 42.6937C248.52 39.732 249.428 31.5221 245.157 22.3757C240.887 13.2294 233.058 18.5833 229.678 22.4035C226.797 15.1925 222.43 17.4682 220.607 19.5073C217.497 13.9112 209.542 4.60354 202.596 12.1416C195.651 19.6796 199.765 31.7849 202.69 36.8953Z",
    fill: "#5E2D1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.005 64.8732C203.741 52.8789 208.633 45.4773 210.987 43.2758C215.481 48.2058 218.762 45.9169 219.841 44.1562C221.869 52.0045 226.076 51.9473 227.925 50.9377C231.099 54.0208 228.813 64.0499 227.273 68.6791C226.73 70.6111 226.968 72.6311 232.261 65.2549C237.555 57.8786 239.565 62.1676 239.907 65.2341C225.704 88.2069 214.093 87.1445 207.609 85.0636C201.125 82.9826 202.085 79.8661 203.005 64.8732Z",
    fill: "#FFA171"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.641 57.8839C225.277 54.7673 222.058 54.2486 220.619 54.3788C219.959 54.0803 220.018 53.6332 220.129 53.447C223.998 52.9818 226.083 56.2111 226.641 57.8839Z",
    fill: "#333333",
    stroke: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.3299,
    cy: 2.26711,
    rx: 1.3299,
    ry: 2.26711,
    transform: "matrix(0.909729 0.411515 -0.347148 0.939225 219.79 57.8381)",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209.776 47.7694C211.469 47.9107 213.158 50.0804 213.79 51.1477C211.502 48.863 209.609 48.9723 208.948 49.3125C208.518 48.7393 208.082 47.6281 209.776 47.7694Z",
    fill: "#333333",
    stroke: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.3299,
    cy: 2.26711,
    rx: 1.3299,
    ry: 2.26711,
    transform: "matrix(0.909729 0.411515 -0.347148 0.939225 209.781 53.3107)",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M237.898 65.4613C237.865 65.4066 237.828 65.3523 237.788 65.2992C237.656 65.4119 237.396 65.7977 236.918 66.7224C236.015 68.4724 234.374 68.2225 233.667 67.8788C235.565 63.9209 237.135 64.4364 237.788 65.2992C237.906 65.1987 237.921 65.3157 237.898 65.4613Z",
    fill: "#F37F4E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.53 73.5032C215.948 74.0094 212.017 74.1808 210.122 74.2706C209.982 75.3435 210.182 76.7122 210.678 78.4984C215.732 83.0572 219.278 72.9443 217.53 73.5032Z",
    fill: "#5C0809"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.731 77.4024C214.811 75.5114 211.567 75.9184 210.185 76.3584C210.225 76.9446 210.515 78.0699 210.655 78.5594C213.605 81.1719 215.879 78.8395 216.731 77.4024Z",
    fill: "#E84C4F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M208.084 67.4549C207.12 66.4508 211.017 62.2964 213.087 60.3447L210.779 68.6738C210.282 68.6859 209.048 68.459 208.084 67.4549Z",
    fill: "#F37F4E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.561 73.4446L140.645 45.9974L155.48 49.9934L151.05 77.3473L136.561 73.4446Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M220.066 254.705C225.763 246.823 246.096 236.731 255.551 232.671C258.894 236.819 262.119 252.931 263.314 260.468C259.788 260.709 239.618 275.056 229.975 282.2L220.066 254.705Z",
    fill: "#4F4F4F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M234.555 180.813C232.095 175.767 229.664 169.416 228.757 166.872C233.166 159.062 242.712 144.194 245.622 147.197C249.26 150.95 251.628 177.7 251.996 181.587C252.363 185.474 236.652 223.522 240.778 227.001C244.904 230.48 244.379 242.312 244.271 246.139C244.162 249.965 241.715 255.53 239.39 254.701C237.53 254.037 234.287 246.674 232.899 243.076L232.36 244.689L230.938 245.592C226.687 235.179 237.631 187.121 234.555 180.813Z",
    fill: "#FFA171"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M250.72 169.879L233.329 178.048L229.377 169.609C235.056 163.72 246.662 152.199 247.659 153.225C248.656 154.251 250.115 164.755 250.72 169.879Z",
    fill: "#F37F4E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M232.328 241.501L233.571 244.745L232.36 244.689L232.328 241.501Z",
    fill: "#F37F4E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.076 270.384L127.913 262.219C132.408 262.167 141.348 262.577 141.14 264.631C140.881 267.2 136.069 272.669 132.8 275.576C130.185 277.902 126.561 273.084 125.076 270.384Z",
    fill: "#FFA171"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M118.405 285.973C112.914 278.135 120.759 270.874 125.175 267.434L126.843 264.811C126.691 266.799 125.539 267.814 128.255 269.279C135.525 273.199 146.502 254.44 149.881 258.259C152.584 261.314 151.664 266.361 150.239 268.3C132.358 278.975 123.895 293.81 118.405 285.973Z",
    fill: "#F2F2F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M144.838 375.081L147.624 355.199L163.792 350.083L157.105 373.244L144.838 375.081Z",
    fill: "#FFA171"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.557 390.99C128.239 385.763 138.574 374.183 143.781 369.046C150.311 374.052 156.262 371.055 158.421 368.931C159.514 369.338 161.413 371.062 160.269 374.705C158.839 379.258 143.854 395.11 139.022 396.785C135.156 398.125 132.107 397.177 131.066 396.536C130.362 396.865 128.874 396.216 128.557 390.99Z",
    fill: "#F2F2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.448 395.682C137.02 390.266 131.692 388.136 129.331 387.748C124.472 400.104 135.962 398.464 139.704 397.577C142.697 396.868 154.372 383.534 159.835 376.956L160.341 374.657C157.569 379.917 145.257 390.865 139.448 395.682Z",
    fill: "#333333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M160.639 360.801L146.996 361.388L146.722 361.518L147.494 355.231L162.891 353.899L160.639 360.801Z",
    fill: "#F37F4E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.919 258.604C109.536 249.847 139.458 214.522 154.967 197.954L216.296 197.967C215.475 194.567 214.764 189.924 218.49 198.558C223.147 209.351 217.094 235.185 195.955 268.997C179.044 296.047 169.204 331.698 163.997 355.821L145.361 357.701C147.535 341.713 147.825 334.282 149.257 316.422C150.709 298.32 159.423 262.359 164.605 246.686C157.234 253.224 141.336 266.503 136.706 267.312C130.919 268.324 119.398 269.55 113.919 258.604Z",
    fill: "#E82A2A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M191.61 263.14C202.883 246.369 208.888 222.696 210.482 212.955C213.375 203.7 219.301 189.611 219.86 207.296C220.559 229.402 201.36 262.181 196.823 267.791C192.287 273.402 183.514 292.145 176.898 309.981C171.606 324.249 166.083 346.528 163.983 355.884L145.662 357.444L161.341 352.332C166.733 329.589 180.337 279.911 191.61 263.14Z",
    fill: "#CD1B1B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.716 282.397C122.053 279.73 118.811 277.085 117.399 276.095C112.823 288.663 120.753 289.288 125.29 288.03C133.558 281.485 150.124 268.377 150.239 268.3C150.354 268.222 150.79 267.276 150.994 266.812L125.529 286.944C125.618 286.54 125.38 285.064 123.716 282.397Z",
    fill: "#333333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M170.851 230.49C168.843 235.631 164.822 246.103 164.803 246.855C164.078 249.163 142.451 264.511 139.133 266.526C136.871 267.9 131.385 267.957 127.823 267.757C127.199 267.831 126.645 267.795 126.17 267.635C126.646 267.679 127.205 267.722 127.823 267.757C136.707 266.692 159.754 243.008 170.851 230.49Z",
    fill: "#CD1B1B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M140.044 142.639C146.189 144.944 165.164 137.228 173.883 133.083C172.051 124.179 165.973 108.344 156.31 116.241C144.232 126.111 147.575 77.0203 149.43 73.5962C151.284 70.1721 143.803 61.9335 142.517 61.3843C141.489 60.9449 138.733 64.221 137.484 65.914L139.846 55.1853C137.938 56.8137 133.639 61.1577 131.704 65.507C129.284 70.9436 136.841 84.9525 137.745 89.4578C138.649 93.9631 132.362 139.758 140.044 142.639Z",
    fill: "#FFA171"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138.116 140.564C144.34 142.511 152.868 125.213 156.354 116.32L156.759 140.038C154.923 140.694 150.01 142.198 145.046 142.972C140.082 143.745 138.357 141.689 138.116 140.564Z",
    fill: "#F37F4E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M139.965 89.65L136.017 84.5278C138.032 89.2646 137.854 90.9078 137.804 92.2472C138.211 90.3952 139.261 89.8886 139.965 89.65Z",
    fill: "#F37F4E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M146.726 79.768C147.385 78.9983 148.228 77.6695 149.16 74.2676L148.477 78.4808C148.477 78.4808 148.249 78.9606 147.805 79.3143C147.36 79.668 146.726 79.768 146.726 79.768Z",
    fill: "#F37F4E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M221.421 94.0693C205.082 105.85 203.067 96.7023 204.947 90.8496C197.35 82.6883 169.657 101.255 156.528 111.361L154.268 148.026L178.227 131.682C177.137 145.081 158.937 180.063 148.327 201.694C169.631 230.919 206.607 215.745 222.335 206.61C219.336 202.23 219.669 178.066 221.953 158.613L226.337 174.811L253.724 152.897C240.109 143.074 243.08 112.35 221.421 94.0693Z",
    fill: "#FFC648"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M214.645 142.641L221.995 158.421C220.167 171.837 220.34 191.596 220.654 199.798C212.41 174.578 213.213 151.185 214.645 142.641Z",
    fill: "#EEA320"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M178.229 131.953L179.837 125.757C179.837 125.757 175.928 130.184 168.121 133.425C160.314 136.666 155.022 135.985 155.022 135.985L154.268 148.026L178.227 131.682L178.229 131.953Z",
    fill: "#EEA320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000000907);
export default __webpack_public_path__ + "static/media/Group 1000000907.45c96a8a226f2ee11eaba7f41c95b230.svg";
export { ForwardRef as ReactComponent };